/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { StateOfGoods } from './StateOfGoods';
import {
    StateOfGoodsFromJSON,
    StateOfGoodsFromJSONTyped,
    StateOfGoodsToJSON,
    StateOfGoodsToJSONTyped,
} from './StateOfGoods';
import type { PreQuoteLocation } from './PreQuoteLocation';
import {
    PreQuoteLocationFromJSON,
    PreQuoteLocationFromJSONTyped,
    PreQuoteLocationToJSON,
    PreQuoteLocationToJSONTyped,
} from './PreQuoteLocation';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { LineItem } from './LineItem';
import {
    LineItemFromJSON,
    LineItemFromJSONTyped,
    LineItemToJSON,
    LineItemToJSONTyped,
} from './LineItem';
import type { EquipmentType } from './EquipmentType';
import {
    EquipmentTypeFromJSON,
    EquipmentTypeFromJSONTyped,
    EquipmentTypeToJSON,
    EquipmentTypeToJSONTyped,
} from './EquipmentType';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface CreateShipment2Request
 */
export interface CreateShipment2Request {
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    shipmentDraftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    shipmentId: string;
    /**
     * 
     * @type {EquipmentType}
     * @memberof CreateShipment2Request
     */
    equipmentType?: EquipmentType;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    pickupDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    deliveryDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    pickupDeadline?: string;
    /**
     * 
     * @type {PreQuoteLocation}
     * @memberof CreateShipment2Request
     */
    pickupLocation: PreQuoteLocation;
    /**
     * 
     * @type {PreQuoteLocation}
     * @memberof CreateShipment2Request
     */
    deliveryLocation: PreQuoteLocation;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof CreateShipment2Request
     */
    lineItems: Array<LineItem>;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    pickupReferenceNumber: string;
    /**
     * Carrier-facing delivery reference. For a delivery to an Amazon distribution warehouse, supply deliveryAmazonReferenceId and deliveryAmazonShipmentId instead - the server packs them into this reference. If both routes are supplied, they must match
     * @type {string}
     * @memberof CreateShipment2Request
     */
    deliveryReferenceNumber?: string;
    /**
     * Amazon Reference ID for a delivery to an Amazon distribution warehouse. Required, along with deliveryAmazonShipmentId, when the delivery locationType is DistributionWarehouse with distributionWarehouseBrand 'amazon'
     * @type {string}
     * @memberof CreateShipment2Request
     */
    deliveryAmazonReferenceId?: string;
    /**
     * Amazon Shipment ID for a delivery to an Amazon distribution warehouse. Required, along with deliveryAmazonReferenceId, when the delivery locationType is DistributionWarehouse with distributionWarehouseBrand 'amazon'
     * @type {string}
     * @memberof CreateShipment2Request
     */
    deliveryAmazonShipmentId?: string;
    /**
     * 
     * @type {Contact}
     * @memberof CreateShipment2Request
     */
    pickupContact?: Contact;
    /**
     * 
     * @type {Contact}
     * @memberof CreateShipment2Request
     */
    deliveryContact?: Contact;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof CreateShipment2Request
     */
    pickupLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof CreateShipment2Request
     */
    pickupLocationHasForklift?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof CreateShipment2Request
     */
    deliveryLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof CreateShipment2Request
     */
    deliveryLocationHasForklift?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShipment2Request
     */
    addInsuranceToShipment: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateShipment2Request
     */
    insuranceAmount: number;
    /**
     * 
     * @type {Currency}
     * @memberof CreateShipment2Request
     */
    insuranceCurrency: Currency;
    /**
     * 
     * @type {StateOfGoods}
     * @memberof CreateShipment2Request
     */
    stateOfGoods: StateOfGoods;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    branchId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipment2Request
     */
    replacesId?: string;
}



/**
 * Check if a given object implements the CreateShipment2Request interface.
 */
export function instanceOfCreateShipment2Request(value: object): value is CreateShipment2Request {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('pickupDate' in value) || value['pickupDate'] === undefined) return false;
    if (!('pickupLocation' in value) || value['pickupLocation'] === undefined) return false;
    if (!('deliveryLocation' in value) || value['deliveryLocation'] === undefined) return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined) return false;
    if (!('pickupReferenceNumber' in value) || value['pickupReferenceNumber'] === undefined) return false;
    if (!('addInsuranceToShipment' in value) || value['addInsuranceToShipment'] === undefined) return false;
    if (!('insuranceAmount' in value) || value['insuranceAmount'] === undefined) return false;
    if (!('insuranceCurrency' in value) || value['insuranceCurrency'] === undefined) return false;
    if (!('stateOfGoods' in value) || value['stateOfGoods'] === undefined) return false;
    return true;
}

export function CreateShipment2RequestFromJSON(json: any): CreateShipment2Request {
    return CreateShipment2RequestFromJSONTyped(json, false);
}

export function CreateShipment2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateShipment2Request {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentDraftId': json['shipmentDraftId'] == null ? undefined : json['shipmentDraftId'],
        'shipmentId': json['shipmentId'],
        'equipmentType': json['equipmentType'] == null ? undefined : EquipmentTypeFromJSON(json['equipmentType']),
        'pickupDate': json['pickupDate'],
        'deliveryDeadline': json['deliveryDeadline'] == null ? undefined : json['deliveryDeadline'],
        'pickupDeadline': json['pickupDeadline'] == null ? undefined : json['pickupDeadline'],
        'pickupLocation': PreQuoteLocationFromJSON(json['pickupLocation']),
        'deliveryLocation': PreQuoteLocationFromJSON(json['deliveryLocation']),
        'lineItems': ((json['lineItems'] as Array<any>).map(LineItemFromJSON)),
        'pickupReferenceNumber': json['pickupReferenceNumber'],
        'deliveryReferenceNumber': json['deliveryReferenceNumber'] == null ? undefined : json['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': json['deliveryAmazonReferenceId'] == null ? undefined : json['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': json['deliveryAmazonShipmentId'] == null ? undefined : json['deliveryAmazonShipmentId'],
        'pickupContact': json['pickupContact'] == null ? undefined : ContactFromJSON(json['pickupContact']),
        'deliveryContact': json['deliveryContact'] == null ? undefined : ContactFromJSON(json['deliveryContact']),
        'pickupLocationHasDock': json['pickupLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasDock']),
        'pickupLocationHasForklift': json['pickupLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasForklift']),
        'deliveryLocationHasDock': json['deliveryLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': json['deliveryLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasForklift']),
        'addInsuranceToShipment': json['addInsuranceToShipment'],
        'insuranceAmount': json['insuranceAmount'],
        'insuranceCurrency': CurrencyFromJSON(json['insuranceCurrency']),
        'stateOfGoods': StateOfGoodsFromJSON(json['stateOfGoods']),
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'replacesId': json['replacesId'] == null ? undefined : json['replacesId'],
    };
}

  export function CreateShipment2RequestToJSON(json: any): CreateShipment2Request {
      return CreateShipment2RequestToJSONTyped(json, false);
  }

  export function CreateShipment2RequestToJSONTyped(value?: CreateShipment2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentDraftId': value['shipmentDraftId'],
        'shipmentId': value['shipmentId'],
        'equipmentType': EquipmentTypeToJSON(value['equipmentType']),
        'pickupDate': value['pickupDate'],
        'deliveryDeadline': value['deliveryDeadline'],
        'pickupDeadline': value['pickupDeadline'],
        'pickupLocation': PreQuoteLocationToJSON(value['pickupLocation']),
        'deliveryLocation': PreQuoteLocationToJSON(value['deliveryLocation']),
        'lineItems': ((value['lineItems'] as Array<any>).map(LineItemToJSON)),
        'pickupReferenceNumber': value['pickupReferenceNumber'],
        'deliveryReferenceNumber': value['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': value['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': value['deliveryAmazonShipmentId'],
        'pickupContact': ContactToJSON(value['pickupContact']),
        'deliveryContact': ContactToJSON(value['deliveryContact']),
        'pickupLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasDock']),
        'pickupLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasForklift']),
        'deliveryLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasForklift']),
        'addInsuranceToShipment': value['addInsuranceToShipment'],
        'insuranceAmount': value['insuranceAmount'],
        'insuranceCurrency': CurrencyToJSON(value['insuranceCurrency']),
        'stateOfGoods': StateOfGoodsToJSON(value['stateOfGoods']),
        'branchId': value['branchId'],
        'replacesId': value['replacesId'],
    };
}

